module.exports = __webpack_public_path__ + "static/media/avatar.004fb4b9.png";